const rand = (arr) => arr[Math.floor(Math.random() * arr.length)];
var rand_default = rand;
export {
  rand_default as default
};
